module.exports = __webpack_public_path__ + "img/1493030126.a40125aa.jpg";